import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'

// Quando il service worker si aggiorna e prende il controllo, ricarica la pagina
// in modo che gli utenti ricevano sempre l'ultima versione deployata.
if ('serviceWorker' in navigator) {
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!reloading) {
      reloading = true;
      window.location.reload();
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
